import { ContactSuggestion } from './contactSuggestions';

export type GroupedContactSuggestions = {
  existingContacts: ContactSuggestion[];
  gmailContacts: ContactSuggestion[];
};

export function groupContactSuggestions(
  suggestions: ContactSuggestion[]
): GroupedContactSuggestions {
  return {
    existingContacts: suggestions.filter(
      (suggestion) => suggestion.source === 'existing_contact'
    ),
    gmailContacts: suggestions.filter(
      (suggestion) => suggestion.source === 'third_party_contact'
    ),
  };
}

export function getContactDisplayName(suggestion: ContactSuggestion): string {
  const firstName = suggestion.first_name?.trim() ?? '';
  const lastName = suggestion.last_name?.trim() ?? '';
  const fullName = `${firstName} ${lastName}`.trim();

  return fullName || suggestion.primary_email;
}

export function getContactInitials(suggestion: ContactSuggestion): string {
  const firstName = suggestion.first_name?.trim() ?? '';
  const lastName = suggestion.last_name?.trim() ?? '';

  if (firstName || lastName) {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  }

  return suggestion.primary_email.charAt(0).toUpperCase();
}
